import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import {NavItem} from "react-bootstrap";
import {Label} from 'reactstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';
import jwt_decode from "jwt-decode";
import Select from 'react-select';
//import { getJSDocReturnTag } from 'typescript';
import CommonNavbar, {navbar} from "./commonNavbar";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {List} from "react-virtualized";

am4core.useTheme(am4themes_animated);

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const month_render =[
    {label:"February",value:2},
    {label:"March",value:3},
];

const brand_render =[
    {label:"XIAOMI",value:5}
];


class NewMerchantMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmit: false,
            //loading: false,
            file_name: null,
            brand_files: [],
            brandData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status: '',
                user_type: '',

            },
            brandModel: false,
            data: [],
            raw_display_data: [],
            loading: false,
            _notificationSystem: null,
            versions: [],
            tableLists: [],
            newRelationModel: false,
            relationData: [{
                tables: "",
                columnLists: "",
                columns: "",
                id: "",
                relationToTables: "",
                toTables: "",
                toColumnLists: "",
                toColumns: ""
            }],
            deleteKeys: [],
            changedItems: [],
            emiMenus: [],
            file_name_display: null,
            selected_month: 2,
            sales_value: null,
            cashback_value: null,
            success_value: null,
            failure_value: null,
            tenures_val: [],
            selected_category: null,
            selected_category_value: [],
            selected_product: null,
            selected_product_value: [],
            default_month: {label: "February", value: 2},
            category_list: [],
            emi_tenure_values: [],
            cust_acq_values: [],
            product_list: [],
            party_master_id: null,
            party_master_name: null,
            selected_merchant: null,
            selected_merchant_value: [],
            selected_chain: null,
            selected_chain_value: [],
            selected_brand: null,
            selected_brand_value: [],
            merchant_list: [],
            default_brand: {label: "XIAOMI", value: 5},
            chain_list: [],
            store_list: [],
            selected_store: null,
            selected_store_value: [],
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[]
        }
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {

        this.getPartyID();
        this._getAllMerchants();
        //this.generateMerchant();
        // this.getFileName();
        console.log(this.props.match.params);
        this.setState({
            _notificationSystem: this.refs.notificationSystem,
            file_name: this.props.match.params.id
        });
        var _notificationSystem = this.refs.notificationSystem;

    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id,
                    party_master_name: values.party_name,
                    loading: false,
                    user_id: decoded._id
                }, () => {
                    if(decoded.userGroup == '7' || decoded.userGroup == 7){
                        this.setState({
                            selected_brand: this.state.party_master_name
                        })
                    }
                    else if(decoded.userGroup == '2' || decoded.userGroup == 2){
                        this.setState({
                            selected_merchant: this.state.party_master_name
                        })
                    }
                })
            })
        });
    }


    _getAllMerchants(){
        axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {

                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    changeMerchant(optionSelected){
        console.log(optionSelected);
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
                this.state.merchantList.move(index,0).join(',');
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);


    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-chain',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            console.log(response.data);
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    changeChain(optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                this.state.chainList.move(index,0).join(',');
            });
        }

        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: []
        });

        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);


    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/brandemi/get-store', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            console.log(response.data);
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }
    changeStore(optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                this.state.storeList.move(index,0).join(',');
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
        //     this.state.yestSend, this.state.todSend);
    }


    handleChange(id, e) {
        console.log(id);
        console.log(e.target.value);
        this.setState({
            changedItems: {...this.state.changedItems, [id]:e.target.value},
            isChange: true
        });
    }


    render() {

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        let category_render = this.state.category_list;
        let product_render = this.state.product_list;
        let merchant_render = this.state.merchant_list;
        console.log(this.state.selected_merchant_value);
        console.log(this.state.storeValue);
        let chain_render = this.state.chain_list;
        let store_render = this.state.store_list;
        console.log(this.state.selected_product_value);
        console.log(this.state.selected_category_value);
        const config ={

        }

        console.log(this.state.changedItems);
        //console.log(this.state.relationData);
        let sales_amount = ''
        if(this.state.sales_value != null){
            sales_amount = (Number(this.state.sales_value)).toLocaleString('en-IN',{ minimumFractionDigits: 2 });
        }
        let cashback_amount = this.state.cashback_value;
        if(this.state.cashback_value != null){
            cashback_amount = (Number(this.state.cashback_value)).toLocaleString('en-IN',{ minimumFractionDigits: 2 });
        }

        let success_amount = this.state.success_value;
        let failure_amount = this.state.failure_value;
        let success_per = (Number(success_amount)*100)/(Number(success_amount)+Number(failure_amount));
        let tenures_display = this.state.tenures_val.map((values, index) =>{
            return(
                <div>
                    {values.tenure}: {values.amount}<br/>
                </div>
            )
        });
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };


        let merchant_displayer = () => {
            if(decoded.userGroup == 2 || decoded.userGroup == '2'){
                return(<div></div>)
            }
            else{
                return(
                    <div>
                        <div className="col-md-3">
                            <Label>Select Merchant:</Label>
                            <ReactMultiSelectCheckboxes name={"merchant_selector"}
                                    components={{ MenuList }}
                                    isClearable={false}
                                    onChange={this.changeMerchant.bind(this)}
                                    styles={customStyles} className="report-listbox"
                                    options={this.state.merchantList}
                                    value={this.state.merchantValue}
                                    isMulti
                            />
                        </div>
                        <div className="col-md-3">
                            <Label>Select Chain:</Label>
                            <ReactMultiSelectCheckboxes name={"chain_selector"}
                                    components={{ MenuList }}
                                    isClearable={false}
                                    onChange={this.changeChain.bind(this)}
                                    styles={customStyles} className="report-listbox"
                                    options={this.state.chainList}
                                    value={this.state.chainValue}
                                    isMulti
                            />
                        </div>
                        <div className="col-md-3">
                            <Label>Select Store:</Label>
                            <ReactMultiSelectCheckboxes name={"store_selector"}
                                    components={{ MenuList }}
                                    isClearable={false}
                                    onChange={this.changeStore.bind(this)}
                                    styles={customStyles} className="report-listbox"
                                    options={this.state.storeList}
                                    value={this.state.storeValue}
                                    isMulti
                            />
                        </div>
                    </div>
                )
            }
        }


        return(
            <div className="content">
                <CommonNavbar/>
                <div className="card top-pad-5">
                    <NotificationSystem ref="notificationSystem" style={style} />
                    <ReactTooltip />
                    <div className="content">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="row">

                            {merchant_displayer()}
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
export default NewMerchantMaster;